module.exports = __webpack_public_path__ + "img/amamizu.526bc6a4.png";